import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

const REACT_ENV = import.meta.env.VITE_REACT_ENV;
const isLocal = import.meta.env.VITE_REACT_LOCAL === "true";

if (!isLocal) {
  Sentry.init({
    dsn: "https://89e7c1671f893b030b204df4a80f398d@o4507858230902784.ingest.de.sentry.io/4508255365759056",
    environment: REACT_ENV,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}
